import { createClassName } from 'utils/createClassName';

import './navigationGroupLayoutStyles.scss';

export const createNavigationGroupLayoutClassName = createClassName(
  'navigation-group-layout'
);
